import { WTROK0 } from "./WTROK0";

export function WTROKP () {
    return <div className="v-box gap-32 center-all">
        <div className="text-32 font-soon">Need good taste?</div>
        <div className="font-treb">Here's the WTROK staff's latest recommendations!</div>
        <div className="v-box gap-16">
            <WTROKREC dj="DJ Bug" title="Tubthumping" artist="Chumbawumba" />
            <WTROKREC dj="DJ Bug" title="Tubthumping" artist="Chumbawumba" />
            <WTROKREC dj="DJ Bug" title="Tubthumping" artist="Chumbawumba" />
            <WTROKREC dj="DJ Bug" title="Tubthumping" artist="Chumbawumba" />
            <WTROKREC dj="DJ Bug" title="Tubthumping" artist="Chumbawumba" />
            <WTROKREC dj="DJ Bug" title="Tubthumping" artist="Chumbawumba" />
            <WTROKREC dj="DJ Bug" title="Tubthumping" artist="Chumbawumba" />
            <WTROKREC dj="DJ Bug" title="Tubthumping" artist="Chumbawumba" />
            <WTROKREC dj="DJ Bug" title="Tubthumping" artist="Chumbawumba" />
            <WTROKREC dj="DJ Bug" title="Tubthumping" artist="Chumbawumba" />
            <WTROKREC dj="DJ Bug" title="Tubthumping" artist="Chumbawumba" />
            <WTROKREC dj="DJ Bug" title="Tubthumping" artist="Chumbawumba" />
            <WTROKREC dj="DJ Bug" title="Tubthumping" artist="Chumbawumba" />
            <WTROKREC dj="DJ Bug" title="Tubthumping" artist="Chumbawumba" />
            <WTROKREC dj="DJ Bug" title="Tubthumping" artist="Chumbawumba" />
            <WTROKREC dj="DJ Bug" title="Tubthumping" artist="Chumbawumba" />
            <WTROKREC dj="DJ Bug" title="Tubthumping" artist="Chumbawumba" />
            <WTROKREC dj="DJ Bug" title="Tubthumping" artist="Chumbawumba" />
        </div>
    </div>
}

function WTROKREC (props: {dj: string, title: string, artist: string})
{
    return <div className="h-box gap-64">
        <div className="font-treb text-24"><b>{props.dj}</b></div>
        <div className="h-box gap-8 font-treb text-24">
            <div className="font-treb text-24">"{props.title}"</div>
            -
            <div className="font-treb text-24">{props.artist}</div>
        </div>
    </div>
}